export function getIndexForTab(tabs, tabName) {
  return tabs.findIndex(({ menuItem }) => menuItem === tabName);
}
